import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'num_of_workrelated_dangerous_occurrences_in_the_last_12_months'

export const dataPointDefinition = {
  retracedId: 'num_of_workrelated_dangerous_occurrences_in_the_last_12_months',
  name: 'Number of work-related dangerous occurrences in the last 12 months (e.g. collapse, partial collapse, explosions, electrical fire, etc.):',
  description:
    'Dangerous occurrences include, e.g.:\r\r\n- collapse, partial collapse, or overturning of lifting devices (e.g., cranes, lifts, hoists, etc.), scaffolding, building or structure, workplace wall or floor;\r\r\n- incidents that could have caused injury or death, or that resulted in closure of the facility for more than 24 hours, including\r\r\n- explosion or collapse of a boiler, boiler tube or other pressure vessel; \r\r\n- electrical short circuit or overload leading to a fire or explosion;\r\r\n- fire or explosion due to ignition of production materials, waste, or finished products.',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-fir-19',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17060,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
